var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./vinmonopoletModuleSetup.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8ccfcc1a\",\"hasScoped\":false}!./vinmonopoletModuleSetup.html"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/vinmonopoletModuleSetup/vinmonopoletModuleSetup.vue
// module id = 2744
// module chunks = 1